import React, { useState, useEffect } from "react";
import { IoLogoWhatsapp } from "react-icons/io5";
import { PiChatsTeardropFill } from "react-icons/pi";
import { Button } from "@material-tailwind/react";

import { useUserContext } from "../../contexts/UserContextProvider";
import { useWhatsappContext } from "../../contexts/WhatsappContextProvider";
import {
  WhatsAppBusinessProfile,
  WhatsAppAnalytics,
  CampaignStatuses,
  WhatsAppConversationInsights,
  SeoTags,
} from "..";

const Overview = () => {
  const {
    daypart,
    daypartFunction,
    apiConversationQuotaLimit,
    isLoadingWaDailyLimits,
    currentUserInfo,
    isUserAdminOrSuperadmin,
    userConversationLimits,
  } = useUserContext();
  const { getWbProfileInfo, getWbPhoneNumberStatus } = useWhatsappContext();

  const [showInsightsType, setShowInsightsType] = useState("message-analytics");

  useEffect(() => {
    daypartFunction();
    getWbProfileInfo();
    getWbPhoneNumberStatus();
    apiConversationQuotaLimit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="space-y-5">
      <SeoTags title="Overview ‣ WaBM" />

      <div className="w-full mt-5 mb-10 lg:my-1">
        <h1 className="text-2xl mb-2">
          Good {daypart} {currentUserInfo?.agentName}!
        </h1>
        <p>
          So what's the plan today? Wanna start up a campaign or check out your
          past activities.
        </p>
      </div>
      <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 space-y-5">
          <div className="space-y-2">
            <h3 className="font-Montserrat text-lg text-wabmBlue">
              Conversation Limits
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {currentUserInfo?.pricingModel === 0 && (
                <div className="wbm-card-1 bg-blue-400 space-y-2">
                  <PiChatsTeardropFill size={30} />
                  <p className="">Subscription Daily Limits (Used/Total)</p>
                  <p className="text-3xl">
                    {userConversationLimits?.conversationUsedCount ||
                    userConversationLimits?.conversationUsedCount === 0
                      ? userConversationLimits?.conversationUsedCount
                      : "NA"}
                    /
                    {userConversationLimits?.conversationLimit
                      ? userConversationLimits?.conversationLimit
                      : "NA"}
                  </p>
                </div>
              )}
              <div className="wbm-card-1 bg-wabmGreen space-y-2">
                <IoLogoWhatsapp size={30} />
                <p className="">WA Daily Limits (Remaining/Total)</p>
                {isLoadingWaDailyLimits ? (
                  <p className="text-xl">Loading...</p>
                ) : (
                  <p className="text-3xl">
                    {userConversationLimits?.totalDailyUsedWhatsAppConversation}
                    /{userConversationLimits?.dailyMessageLimit}
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <p>
              Click one of the following buttons to view preferred insights.
            </p>
            <div className="flex flex-wrap lg:flex-nowrap gap-2">
              <Button
                type="button"
                variant="gradient"
                color={
                  showInsightsType === "message-analytics" ? "green" : "blue"
                }
                onClick={() => {
                  setShowInsightsType("message-analytics");
                }}
                className="w-full md:w-36 xl:w-auto"
              >
                Message Analytics
              </Button>
              {isUserAdminOrSuperadmin() && (
                <Button
                  type="button"
                  variant="gradient"
                  color={
                    showInsightsType === "conversation-insights"
                      ? "green"
                      : "blue"
                  }
                  onClick={() => {
                    setShowInsightsType("conversation-insights");
                  }}
                  className="w-full md:w-36 xl:w-auto"
                >
                  Conversation Insights
                </Button>
              )}
            </div>
          </div>

          {showInsightsType === "message-analytics" && <WhatsAppAnalytics />}
          {isUserAdminOrSuperadmin() &&
            showInsightsType === "conversation-insights" && (
              <div className="wbm-card-2 space-y-3">
                <WhatsAppConversationInsights />
              </div>
            )}
          {showInsightsType === "campaign-statuses" && <CampaignStatuses />}
        </div>

        <WhatsAppBusinessProfile />
      </div>
    </main>
  );
};

export default Overview;
